import api from './api';

const procurementService = {
  getSuppliers:    (token)       => api.get('/procurement/suppliers', token),
  createSupplier:  (data, token) => api.post('/procurement/suppliers', data, token),
  getStock:        (token)       => api.get('/procurement/stock', token),
  getOrders:       (token)       => api.get('/procurement/orders', token),
  createOrder:     (data, token) => api.post('/procurement/orders', data, token),
  getBondWarehouse:(token)       => api.get('/procurement/bond-warehouse', token),
  getMOCTracking:  (token)       => api.get('/procurement/moc-tracking', token),
};

export default procurementService;
